<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <Modal
          v-model="importModal"
          title="导入高龄津贴数据"
          width="660px"
          height="400px"
          :footer-hide="true"
          @on-cancel="closeModel"
        >
          <i-form>
            <row :gutter="80">
              <i-col span="8">
                <form-item label="所属区域">
                  <Cascader
                    v-model="comList1"
                    :data="communityList1"
                    placeholder="请选择"
                    clearable
                    @on-change="communityChange1"
                  ></Cascader>
                </form-item>
              </i-col>
            </row>
          </i-form>
          <!--/assets/企业导入模板.xlsx-->
          <div class="note box">
            请上传符合模板要求的高龄津贴文件,支持.xlsx格式
            <a
              class="download"
              href="https://py.shequyun.cn/base/mongofile/default/5feab9b0bb1d8b0001a2e5ba.xlsx"
              download="高龄津贴模板"
              >下载模板</a
            >
          </div>
          <Upload
            ref="upload"
            :show-upload-list="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :headers="header"
            :action="actionuri"
            :on-success="handleSuccess"
            :on-progress="handleProgress"
            :on-error="handleError"
          >
            <Button :loading="uploadLoading" type="primary">导入数据</Button>
          </Upload>
        </Modal>
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="所属区域">
                <Cascader
                  v-model="comList"
                  :data="communityList"
                  placeholder="请选择"
                  clearable
                  @on-change="communityChange"
                  change-on-select
                ></Cascader>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="老人姓名" prop="name">
                <Input
                  v-model="query.name"
                  clearable
                  placeholder="请输入老人姓名"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="老人身份证号" prop="idCardNO">
                <Input
                  v-model="query.idCardNO"
                  clearable
                  placeholder="请输入老人身份证号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="年龄" prop="ageRange">
                <Select v-model="query.ageRange" clearable>
                  <Option
                    v-for="item in ageList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.age"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <!-- <i-col span="6">
              <form-item label="街道审核状态" prop="type">
                <Select v-model="query.streetAudit" clearable>
                  <Option
                    v-for="item in statusList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col> -->
            <i-col span="6">
              <form-item label="审核状态" prop="type">
                <Select v-model="query.administrationAudit" clearable>
                  <Option
                    v-for="item in statusList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="申请时间" prop="eventtime">
                <DatePicker
                  v-model="time"
                  class="time"
                  type="daterange"
                  placeholder="请选择时间"
                ></DatePicker>
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>
      <div class="table-data">
        <page-head
          :title="''"
          :btn-list="btnList1"
          :show-back="false"
          @handleBtn="handleBtn1"
        ></page-head>
        <i-table
          class="i-table"
          :columns="tableHeader"
          :border="true"
          :loading="isTableLoading"
          :data="tableData"
          stripe
          ref="table"
          @on-row-dblclick="handleClickDetail"
          @on-selection-change="handleSelect"
          ><template slot-scope="{ row, index }" slot="communityPathname">
            <span> {{ shutAreaname(row.communityPathname) }}</span>
          </template>
          <template slot-scope="{ row, index }" slot="updateTime">
            <span>
              {{
                (!row.administrationAudit ||
                  parseInt(row.administrationAudit) == 0) &&
                (!row.streetAudit || parseInt(row.streetAudit) == 0)
                  ? ""
                  : row.updateTime
              }}</span
            >
          </template>
          <template slot-scope="{ row, index }" slot="applicantMode">
            <span>{{ row.applicantMode == 1 ? "本人办理" : "家属代办" }}</span>
          </template>
          <template slot-scope="{ row, index }" slot="administrationAudit">
            <span
              :class="[parseInt(row.administrationAudit) == 1 ? 'success' : '']"
              >{{
                parseInt(row.administrationAudit) == 1
                  ? "审核通过"
                  : !row.administrationAudit ||
                    parseInt(row.administrationAudit) == 0
                  ? "待审核"
                  : "审核未通过"
              }}</span
            >
          </template>
          <!-- <template slot-scope="{ row, index }" slot="streetAudit">
            <span
              :class="[parseInt(row.streetAudit)==1 ? 'success':'']"
            >{{parseInt(row.streetAudit) == 1?'审核通过':(!row.streetAudit || parseInt(row.streetAudit)==0 ? '待审核':'审核未通过')}}</span>
          </template> -->
          <template slot-scope="{ row, index }" slot="action">
            <span @click="handleClickDetail(row)" class="action">[详情]</span>
            <Poptip
              confirm
              title="确认删除?"
              placement="left"
              @on-ok="handleClickDelete(row)"
              v-if="showDelete"
            >
              <span
                click="handleClickDetail(row)"
                style="margin-left: 10px; color: #ff7b44"
                >删除</span
              >
            </Poptip>
          </template>
        </i-table>
        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            @on-change="pageChange"
            show-total
          />
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { applyList, applyDelete, applyExport, updateAuditStatus } = api;
const STATUSMAP = {
  0: {
    status: "待审核",
  },
  1: {
    status: "审核通过",
  },
  2: {
    status: "审核未通过",
  },
  100: {
    status: "",
  },
};
export default {
  name: "apply",
  components: {
    pageHead,
  },

  data() {
    return {
      showDelete:true,
      typeList: [
        {
          index: 1,
          status: "本人办理",
        },
        {
          index: 2,
          status: "家属代办",
        },
      ],
      statusList: [
        {
          index: 0,
          type: "待审核",
        },
        {
          index: 1,
          type: "审核通过",
        },
        {
          index: 2,
          type: "审核未通过",
        },
      ],
      ageList: [
        // {
        //   index: 0,
        //   age: "全部"
        // },
        {
          index: 1,
          age: "80-90",
        },
        {
          index: 2,
          age: "90-100",
        },
        {
          index: 3,
          age: "100以上",
        },
      ],
      time: "",
      query: {
        communityId: "",
        communityId1: "",
        name: "",
        idCardNO: "",
        phoneNO: "",
        applicantMode: "",
        administrationAudit: "",
        streetAudit: "",
        ageRange: "",
        endDate: "",
        endDate: "",
      },
      communityList: [],
      communityList1: [],
      comList: [],
      comList1: [],
      isTableLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      actionuri: "",
      uploadLoading: false,
      importModal: false,
      selectionList: [],
      title: "高龄津贴申请",
      btnList: [
        {
          name: "重置",
          type: "reset",
        },
        {
          name: "搜索",
          type: "search",
        },
        {
          name: "新增",
          type: "add",
        },
        {
          name: "导入",
          type: "import",
        },
        {
          name: "导出",
          type: "export",
        },
      ],
      btnList1: [
        {
          name: "审核通过",
          type: "checkPass",
        },
        {
          name: "审核不通过",
          type: "checkFail",
        },
      ],
      tableHeader: [
        {
          type: "selection",
          width: 70,
          align: "center",
          fixed: "left",
        },
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
          fixed: "left",
        },
        {
          title: "老人姓名",
          key: "name",
          width: 100,
          align: "center",
          fixed: "left",
        },
        {
          title: "年龄",
          key: "age",
          width: 80,
          align: "center",
        },
        {
          title: "老人身份证号",
          key: "idCardNO",
          width: 180,
          align: "center",
        },
        {
          title: "所属区域",
          slot: "communityPathname",
          width: 200,
          align: "center",
        },
        {
          title: "老人家庭地址",
          key: "address",
          width: 200,
          align: "center",
        },
        {
          title: "老人/家属联系电话",
          key: "phoneNO",
          width: 160,
          align: "center",
        },
        {
          title: "申办人",
          slot: "applicantMode",
          width: 100,
          align: "center",
        },
        {
          title: "申请时间",
          key: "createTime",
          width: 100,
          align: "center",
        },
        {
          title: "审核人",
          key: "checkUserName",
          width: 80,
          align: "center",
        },
        {
          title: "审核时间",
          key: "checkTime",
          width: 190,
          align: "center",
        },
        // {
        //   title: "街道审核状态",
        //   slot: "streetAudit",
        //   width: 130,
        //   align: "center"
        // },
        {
          title: "审核状态",
          slot: "administrationAudit",
          width: 140,
          align: "center",
        },
        {
          title: "  操作",
          slot: "action",
          width: 160,
          align: "left",
        },
      ],
      tableData: [],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  methods: {
    async handleClickDelete(row) {
      let res = await this.$delete(applyDelete, {
        idList: row.id,
      });
      if (res.isSucceed) {
        this.$Message.success("删除成功");
        this.pageChange(this.pageNum);
      }
    },
    shutAreaname(communityPathname) {
      let result = "";
      if (communityPathname) {
        let newcommunityPathname = communityPathname.slice(
          0,
          communityPathname.length
        );
        result = newcommunityPathname.replace(/\./g, "");
      }
      return result;
    },
    handleBtn(type) {
      if (type == "reset") {
        this.time = "";
        this.pageNum = 1;
        this.comList = [];
        this.query.applicantMode = "";
        this.query.administrationAudit = "";
        this.query.streetAudit = "";
        this.query.communityId = this.$store.state.streetorcommunityid;
        this.query.ageRange = "";
        this.$refs.search.resetFields();
        this.getApplyList();
      } else if (type == "search") {
        this.pageNum = 1;
        this.getApplyList();
      } else if (type == "import") {
        this.importAllowance();
        this.pageNum = 1;
        this.getApplyList();
      } else if (type == "add") {
        this.handleClickAdd();
      } else {
        let {
          communityId,
          name,
          idCardNO,
          ageRange,
          streetAudit,
          administrationAudit,
          beginDate,
          endDate,
        } = this.query;
        ageRange = ageRange ? ageRange : "";
        console.log(communityId);
        let url =
          applyExport +
          "?name=" +
          name +
          "&communityId=" +
          communityId +
          "&idCardNO=" +
          idCardNO +
          "&ageRange=" +
          ageRange +
          "&streetAudit=" +
          streetAudit +
          "&administrationAudit=" +
          administrationAudit +
          "&beginDate=" +
          beginDate +
          "&endDate=" +
          endDate +
          "&token=" +
          this.header.token;
        console.log(url);
        window.open(url);
      }
    },
    handleBtn1(type) {
      if (type == "checkPass") {
        console.log("checkPass");
        if (this.selectionList.length == 0) {
          return this.$Message.warning("请选择要审核的项目");
        }
        console.log(this.selectionList);
        this.artificial(1); //1--审核成功,2--审核失败
      } else {
        console.log("checkFail");
        if (this.selectionList.length == 0) {
          return this.$Message.warning("请选择要审核的项目");
        }
        this.artificial(2);
      }
    },
    async artificial(status) {
      //审核通过
      try {
        let data = {
          administrationAudit: status,
          id: this.selectionList.join(","),
        };
        console.log(data);
        let res = await this.$get(updateAuditStatus, data);
        if (res.isSucceed) {
          this.$Message.success("操作成功");
          this.getApplyList();
        } else {
          this.$Message.error("操作失败 " + res.message);
        }
      } finally {
      }
    },
    handleClickDetail(item) {
      console.log(item);
      this.$router.push({
        name: "applyDetail",
        query: { id: item.id },
      });
    },
    handleSelect(selection) {
      this.selectionList = [];
      selection.forEach((item) => {
        this.selectionList.push(item.id);
      });
      console.log(this.selectionList);
    },
    handleClickAdd(item) {
      console.log(item);
      this.$router.push({
        name: "applyDetail",
        // query: { id: null },
      });
    },
    pageChange(val) {
      this.pageNum = val;
      this.getApplyList();
    },
    getCommunity() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
        lowestLevelId: 10000007770009,
      })
        .then((res) => {
          this.communityList = res.rows.length
            ? this.formateData(res.rows)
            : [];
          console.log(this.communityList);
        })
        .catch((e) => {
          this.$Message.error("获取行政区域失败");
        });
    },
    getCommunity1() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
        lowestLevelId: 10000007770008,
      })
        .then((res) => {
          this.communityList1 = res.rows.length
            ? this.formateData(res.rows)
            : [];
          console.log(this.communityList1);
        })
        .catch((e) => {
          this.$Message.error("获取行政区域失败");
        });
    },
    formateData(data) {
      let returnData = data.map((item) => {
        return {
          value: {
            communityId: item.communityId,
            childrenIdList: item.childrenIdList,
          },
          label: item.communityName,
          children: item.children.length ? this.formateData(item.children) : [],
        };
      });
      return returnData;
    },
    closeModel(data) {
      this.importModal = false;
    },
    importAllowance() {
      var idlist = this.communityList1;
      if (this.$store.state.isJiedao == 1) {
        if (!idlist.length || idlist.length > 1) {
          this.$Message.warning("请选择一个行政区域");
          return;
        }
      }
      this.importModal = true;
    },
    communityChange(value) {
      let returndata = value[value.length - 1];
      this.query.communityId = returndata.communityId;
    },
    communityChange1(value) {
      let returndata = value[value.length - 1];
      this.query.communityId1 = returndata.communityId;

      let streetId = "";
      if (this.$store.state.isJiedao == 1) {
        streetId = this.query.communityId1;
      } else {
        streetId = this.$store.state.streetorcommunityid;
      }
      console.log(streetId);
      console.log(returndata);
      if (returndata && returndata.childrenIdList.length == 0) {
        if (this.actionuri.includes("?")) {
          this.actionuri = this.actionuri.substring(
            0,
            this.actionuri.indexOf("?")
          );
        }
        this.actionuri += `?streetId=${streetId}`;
        console.log("url", this.actionuri);
      }
    },
    handleProgress() {
      this.uploadLoading = true;
    },
    handleSuccess(e) {
      console.log(e);
      this.uploadLoading = false;
      this.importModal = false;
      if (e.isSucceed) {
        this.$Message.success(e.message);
        this.pageNum = 1;
        this.getApplyList();
      } else {
        this.$Message.error(e.message);
      }
    },
    handleError(e) {
      console.log(e);
      this.uploadLoading = false;
      this.importModal = false;
      this.$Message.error("导入失败");
    },
    async getApplyList() {
      this.isLoading = true;
      try {
        if (this.time[0]) {
          this.query.beginDate = this.$util.FormatDate(
            new Date(this.time[0]),
            "yyyy-MM-dd"
          );
          this.query.endDate = this.$util.FormatDate(
            new Date(this.time[1]),
            "yyyy-MM-dd"
          );
        }
        let res = await this.$post(applyList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          communityId: this.$store.state.streetorcommunityid,
          ...this.query,
        });
        console.log(this.query);

        let list = res.rows.map((item) => ({
          ...item,
        }));
        // console.log(list);
        this.tableData = list;
        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    },
  },

  created() {
    this.getCommunity();
    this.getCommunity1();
    this.getApplyList();
    console.log(this.$store.state.streetorcommunityid);
    this.actionuri = this.urlobj.importExcel;

    //如果是南乐县下的乡，关闭删除按钮
     let path = this.$store.state.path + ''
    let patharr = path.split(',')
    if(patharr.length >4 && path.indexOf('410923000000')>-1){
      
      this.showDelete = false
    }
    //结束
  },
  mounted() {},
};
</script>

<style  scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}
.time {
  width: 100%;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .success {
    color: #ff7b44;
  }
  .action {
    color: #5e6d94;
    cursor: pointer;
    margin-right: 10px;
  }
  .i-table {
    margin-top: 20px;
  }
}
</style>